module.exports = __webpack_public_path__ + "img/verizon.694d6ede.png";